import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Upload,
  message,
  Space,
  Checkbox,
  Slider,
  TreeSelect,
  Modal,
  Drawer,
  Divider,
  Typography,
  Card,
} from "antd";
import CustomImageCrop from "./CustomImageCrop";
import PreviewBanner from "./PreviewBanner";
import { List } from "antd";
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import uploadSvg from "../../../../assets/icons/icons/upload.svg";
import magicIcon from "../../../../assets/icons/magic.png";
import "./JobForm.scss";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import Compressor from "compressorjs";
import { useLocation } from "react-router-dom";
import {
  CloseOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import DeleteIcon from "../../../../assets/icons/DetailedProfile/delete.svg";
import TargetProfile from "./TargetProfile";
import TextArea from "antd/lib/input/TextArea";
import { compressImage } from "utils";
import AssessmentTable from "./AssessmentTable";

const { Option } = Select;
const { TreeNode } = TreeSelect;

interface Props {
  onFinish?: any;
  salaryRange: any;
  setSalaryRange: any;
  imageData?: any;
  setRecruiters: any;
  setisAnonymous: any;
  companies: any;
  currencies: any;
  contractTypes: any;
  countries: any;
  skills: any;
  submitting: boolean;
  jobFields: [];
  inspiringCompanies: [];
  job?: any;
  isAnonymous?: any;
  recruiters?: any;
  hasError?: boolean;
  isLoading?: boolean;
  draftLoader?: boolean;
  setDraftLoader?: any;
  editMode?: boolean;
  setAnonymousCompanyDescription?: any;
  setJobDescription?: any;
  setComments: any;
  setUploadMobileBanner: any;
  uploadMobileBanner: any;
  uploadBanner: any;
  setUploadBanner: any;
  addAssessment: any;
  assessments: any;
  handleSaveJobAsDraft: any;
}

const JobForm: React.FC<Props> = ({
  onFinish,
  isLoading,
  draftLoader,
  setDraftLoader,
  editMode,
  hasError,
  submitting,
  companies,
  currencies,
  contractTypes,
  countries,
  skills,
  jobFields,
  inspiringCompanies,
  job,
  isAnonymous,
  recruiters,
  salaryRange,
  setSalaryRange,
  setRecruiters,
  setisAnonymous,
  setAnonymousCompanyDescription,
  setJobDescription,
  setComments,
  setUploadMobileBanner,
  uploadMobileBanner,
  uploadBanner,
  setUploadBanner,
  addAssessment,
  assessments,
  imageData,
  handleSaveJobAsDraft,
}) => {
  const location: any = useLocation();
  const [form]: any = Form.useForm();
  const [companyId, setCompanyId] = useState(null);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);
  const [imgLoad, setImgLoad] = useState(false);
  const [fileList, setFileList] = useState<any>([]);
  const [fileListBanner, setFileListBanner] = useState<any>([]);
  const [progress, setProgress] = useState(0);
  const [defaultFileList, setDefaultFileList] = useState([]);
  const [imagePreview, setImagePreview] = useState("");
  const [imagePreviewModel, setImagePreviewModal] = useState(false);
  const [imagePreviewBanner, setImagePreviewBanner] = useState("");
  const [imagePreviewModelBanner, setImagePreviewModalBanner] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState<any>(null);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [cropImageUrl, setCropImageUrl] = useState("");
  const [cropImageType, setCropImageType] = useState<"mobile" | "banner">(
    "mobile"
  );
  const [tempImageFile, setTempImageFile] = useState<File | null>(null);
  const [cropLoading, setCropLoading] = useState(false);

  const marks = {
    0: `${selectedCurrency?.symbol || "$"}0`,
    5000: `${selectedCurrency?.symbol || "$"}5k`,
    10000: `${selectedCurrency?.symbol || "$"}10k`,
    15000: `${selectedCurrency?.symbol || "$"}15k`,
    20000: `${selectedCurrency?.symbol || "$"}20k`,
    25000: `${selectedCurrency?.symbol || "$"}25k`,
    30000: `${selectedCurrency?.symbol || "$"}30k`,
    35000: `${selectedCurrency?.symbol || "$"}35k`,
    40000: {
      label: <strong>{`${selectedCurrency?.symbol || "$"}40k`}</strong>,
    },
  };

  const { placePredictions, getPlacePredictions, isPlacePredictionsLoading } =
    useGoogle({
      apiKey: "AIzaSyACXA9qapZNvq51WpF69eIH908sX_efNMs",
      options: {
        types: ["geocode"],
      },
    });
  const [value, setValue] = useState("");

  useEffect(() => {
    if (job?.currency) {
      setSelectedCurrency(job.currency);
    }
  }, [job?.currency]);

  const handleChangeCurrency = (value: any, option: any) => {
    const updatedCurrency = currencies.find((item: any) => item.name === value);
    updatedCurrency && setSelectedCurrency(updatedCurrency);
  };

  const onChangeCompanySelection = (companyId: any) => {
    // console.log("Selected Value: ", companyId);
    setCompanyId(companyId);
    // setCompany(companyId);
    form.resetFields(["recruiters", "leadRecruiter"]);
    setRecruiters([]);
    setSelectedRecruiters([]);
  };
  const MIN_IMAGE_SIZE = 3 * 1000 * 1000; // 3MB
  const MAX_IMAGE_SIZE = 10 * 1000 * 1000; // 10MB

  const beforeUpload = (file: any) => {
    setImgLoad(true);
    const img = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg",
      "image/svg+xml",
    ];

    const isImg = img.includes(file.type);
    if (!isImg) {
      setImgLoad(false);
      message.error("You can only upload gif, jpeg, png, svg files!");
      return false;
    }

    if (file.size < MIN_IMAGE_SIZE) {
      setImgLoad(false);
      message.error("File size is too small (Minimum is 3MB)!");
      return false;
    }

    if (file.size > MAX_IMAGE_SIZE) {
      setImgLoad(false);
      message.error("File size exceeds the limit (10MB)!");
      return false;
    }

    return true;
  };

  const handleFileSelect = (file: File, type: "mobile" | "banner") => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setCropImageUrl(e.target?.result as string);
      setCropImageType(type);
      setTempImageFile(file);
      setCropModalVisible(true);
    };
    reader.readAsDataURL(file);
    return false; // Prevent default upload
  };

  const onRemove = (file: any) => {
    if (file) {
      setImgLoad(false);
      setFileList([]);
      setUploadMobileBanner(null);
    }
  };
  const onRemoveBanner = (file: any) => {
    // console.log(file);
    if (file) {
      setFileListBanner([]);
      setUploadBanner(null); // This will be handled by the parent component
    }
  };

  const onPreview = async (file: any) => {
    setImagePreviewModal(true);
  };
  const onPreviewBanner = async (file: any) => {
    setImagePreviewModalBanner(true);
  };

  const salaryChangeHandler = (value: any) => {
    // console.log("Selected Slider Value: ", value);
    setSalaryRange(value);
  };

  const onRecruiterSelected = (value: any, label: any) => {
    const fullList: any = label.map((selected: any) => {
      return { value: selected.value, label: selected.children };
    });
    // console.log("====>>>>>> ", fullList);
    setSelectedRecruiters(fullList);
  };

  console.log(
    "-----hide salary",
    job?.hideSalary,
    "isConfidential",
    job?.isConfidential
  );
  const handleAnonymousCompanyDescriptionEditorChange = (
    content: any,
    editor: any
  ) => {
    // console.log("Content was updated:", content);
    setAnonymousCompanyDescription(content);
  };

  const handleEditorChange = (content: any, editor: any) => {
    // console.log("Content was updated:", content);
    setJobDescription(content);
  };

  const handleCommentChange = (content: any, editor: any) => {
    setComments(content);
  };

  const resizeFile = (file: any): Promise<File | Blob> =>
    new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        success(result: File | Blob) {
          // console.log({ result });
          resolve(result);
        },
        error(err) {
          console.log(err.message);
          reject(err);
        },
      });
    });

  const jobFieldsTreeList = () => {
    const parentJobFields = jobFields.filter(
      (jobField: any) => jobField.parent == null
    );
    const childJobFields = jobFields.filter(
      (jobField: any) => jobField.parent !== null
    );
    return parentJobFields.map((parentJobField: any) => {
      return (
        <TreeNode
          key={parentJobField._id}
          value={parentJobField.title}
          title={parentJobField.title}
        >
          {childJobFields
            .filter(
              (jobField: any) => jobField.parent._id === parentJobField._id
            )
            .map((child: any) => (
              <TreeNode
                key={child._id}
                value={child.title}
                title={child.title}
              />
            ))}
        </TreeNode>
      );
    });
  };
  useEffect(() => {
    //clearin form fields on post a job modal
    if (location?.state == "clearFields") {
      // console.log("Clearing");
      form.setFieldsValue({
        title: "",
        companyId: null,
        description: "",
        countries: [],
        experiance: "",
        requiredSkills: [],
        recruiters: [],
        leadRecruiter: null,
        fields: [],
        contractType: null,
        salaryRange: "",
        targetCompanies: [],
        language: "en",
        jobBanner: "",
      });

      setFileList([]);
      setUploadMobileBanner(null);
      setFileListBanner([]);
      setUploadBanner(null);
    }
  }, [location]);

  useEffect(() => {
    if (job) {
      // console.log("Found job in the form : ", job);
      form.setFieldsValue({
        title: job.title,
        companyId: job?.company?.name,
        description: job.description,
        countries: job.countries.map((c: any) => c.name),
        experiance: job.experience,
        requiredSkills: job.requiredSkills.map((rs: any) => rs.title),
        recruiters: job.recruiters.map((rec: any) => rec.email),
        leadRecruiter: job.leadRecruiter.email,
        fields: job.fields.map((c: any) => c.title),
        contractType: job.contractType.name,
        salaryRange: job.salaryPackage,
        currencyId: job?.currency?.name,
        targetCompanies: job.targetCompanies.map((c: any) => c.name),
        language: job.language || "en",
        mobileBanner: job.mobileBanner,
        jobBanner: job.banner,
        total: job.yearlyCompensation?.total,
        base: job.yearlyCompensation?.total,
        onTargetEarnings: job.yearlyCompensation?.onTargetEarnings,
        shortTermIncentives: job.yearlyCompensation?.shortTermIncentives,
        longTermIncentives: job.yearlyCompensation?.longTermIncentives,
        other: job.yearlyCompensation?.other,
        comments: job.yearlyCompensation?.comments,
        hideSalary: job.hideSalary,
        isConfidential: job.isConfidential,
      });

      // setRecruiters(job.recruiters)
      setRecruiters(job.company.users);
      setSelectedRecruiters(
        job?.company?.users.map((item: any) => ({
          value: item._id,
          label: item.email,
        }))
      );
      setSalaryRange(parseInt(job.salaryPackage));

      if (job.mobileBanner) {
        setFileList([
          {
            uid: job._id,
            name: job.name,
            status: "done",
            url: job.mobileBanner ? job.mobileBanner : "",
          },
        ]);
        setUploadMobileBanner(job.mobileBanner);
        setImagePreview(job.mobileBanner);
      }

      if (job.banner) {
        setFileListBanner([
          {
            uid: job._id,
            name: "No image",
            status: "done",
            url: job.banner ? job.banner : "",
          },
        ]);
        // Fix: Set uploadBanner with the correct structure when editing
        setUploadBanner({ url: job.banner });
        setImagePreviewBanner(job.banner);
      }
    } else {
      /* Setting English by default */
      form.setFieldsValue({
        language: "en",
        currencyId: "USD",
        isConfidential: false,
        hideSalary: false,
      });
    }
  }, [job]);

  useEffect(() => {
    if (companies) {
      const companyObj = companies.find(
        (company: any) => company.name == companyId
      );
      // console.log("===> ", companyObj);
      setRecruiters(companyObj.users);
    }
  }, [companyId]);

  const onValuesChange = () => {
    setIsSaveDisabled(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setIsSaveDisabled(true);
    }, 1500);
  }, []);

  const dataURIToBlob = (dataURI: any) => {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  };

  const uploadImage = async (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    const image = await resizeFile(file);
    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("upload_preset", "cqdbrmkw");
    fmData.append("file", image);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_REST_URL}/upload/job/assets`,
        fmData,
        config
      );

      onSuccess("Ok");
      // console.log("server res: ", res);
      setImagePreview(res.data.secure_url);
      setUploadMobileBanner(res.data.secure_url);
      return true;
    } catch (err) {
      console.log("Eroor: ", err);
      const error = new Error("Some error");
      onError({ err });
      return false;
    }
  };

  const uploadImageBanner = async (options: any) => {
    const { onSuccess, onError, file, onProgress } = options;
    // console.log(file);
    const image = await resizeFile(file);
    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("upload_preset", "cqdbrmkw");
    fmData.append("file", image);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_REST_URL}/upload/job/assets`,
        fmData,
        config
      );

      onSuccess("Ok");
      // console.log("server res: ", res);
      setImagePreviewBanner(res.data.secure_url);
      setUploadBanner({ url: res.data.secure_url }); // Fix: Set with correct structure
      return true;
    } catch (err) {
      console.log("Error: ", err);
      const error = new Error("Some error");
      onError({ err });
      return false;
    }
  };

  const handleOnChange = async (e: any) => {
    setIsSaveDisabled(false);
    setImgLoad(true);

    const img = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg",
      "image/svg+xml",
    ];

    const isImg = img.includes(e.file.type);

    if (isImg) {
      const latestFile = e.file.originFileObj;

      if (latestFile) {
        try {
          // Compress the image
          const compressedFile = await compressImage(latestFile);
          handleFileSelect(compressedFile, "mobile");
        } catch (error) {
          console.error("Image compression failed:", error);
          setFileList([]);
          form.setFieldsValue({
            mobileBanner: null,
          });
        }
      }
    } else {
      setFileList([]);
      form.setFieldsValue({
        mobileBanner: null,
      });
    }
  };

  const handleOnChangeBanner = async (e: any) => {
    setIsSaveDisabled(false);
    setImgLoad(true);

    const img = [
      "image/gif",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/svg",
      "image/svg+xml",
    ];

    const isImg = img.includes(e.file.type);

    if (isImg) {
      const latestFile = e.file.originFileObj;

      if (latestFile) {
        try {
          // Compress the image
          const compressedFile = await compressImage(latestFile);
          handleFileSelect(compressedFile, "banner");
        } catch (error) {
          console.error("Image compression failed:", error);
          setFileListBanner([]);
          form.setFieldsValue({
            jobBanner: null,
          });
        }
      }
    } else {
      setFileListBanner([]);
      form.setFieldsValue({
        jobBanner: null,
      });
    }
  };

  const saveAsDraftHandler = () => {
    form
      .validateFields(["title", "companyId", "recruiters", "leadRecruiter"])
      .then(() => {
        handleSaveJobAsDraft(form.getFieldsValue(true), true);
      })
      .catch(() => {
        form.scrollToField("title");
      });
  };

  const handleCropApply = async (croppedImageUrl: string) => {
    try {
      // Convert data URL to blob
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File(
        [blob],
        tempImageFile?.name || "cropped-image.jpg",
        { type: "image/jpeg" }
      );

      // Upload the cropped image
      const formData = new FormData();
      formData.append("upload_preset", "cqdbrmkw");
      formData.append("file", file);

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_REST_URL}/upload/job/assets`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );

      if (cropImageType === "mobile") {
        setFileList([
          {
            uid: Date.now(),
            name: file.name,
            status: "done",
            url: res.data.secure_url,
          },
        ]);
        setUploadMobileBanner(res.data.secure_url);
        setImagePreview(res.data.secure_url);
        form.setFieldsValue({ mobileBanner: res.data.secure_url });
      } else {
        setFileListBanner([
          {
            uid: Date.now(),
            name: file.name,
            status: "done",
            url: res.data.secure_url,
          },
        ]);
        // Fix: Set uploadBanner with the structure parent component expects
        setUploadBanner({ url: res.data.secure_url });
        setImagePreviewBanner(res.data.secure_url);
        form.setFieldsValue({ jobBanner: res.data.secure_url });
      }

      setCropModalVisible(false);
      setCropImageUrl("");
      setTempImageFile(null);
      message.success("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      message.error("Upload failed. Please try again.");
    }
  };

  const handleCropCancel = () => {
    setCropModalVisible(false);
    setCropImageUrl("");
    setTempImageFile(null);
  };

  return (
    <Form
      name="registration-form"
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      scrollToFirstError
    >
      <Row gutter={24}>
        {/* Left Column */}
        <Col span={12}>
          {/* Job Details Section */}
          <div className="section-container">
            <div className="section-header">
              <h3>Job details</h3>
            </div>

            <Form.Item
              name="title"
              label={<span style={{ fontSize: 14 }}>Job title</span>}
              rules={[
                {
                  required: true,
                  message: "Please input the job title",
                },
              ]}
              // hasFeedback
            >
              <Input
                type="text"
                placeholder="VP Human Resources,Digital Transformation Director..."
                maxLength={45}
                defaultValue={job && job.name}
              />
            </Form.Item>

            <Form.Item
              name="companyId"
              className="add-job-company-field"
              label={<span style={{ fontSize: 14 }}>Company</span>}
              rules={[
                {
                  required: true,
                  message: "Select a company",
                },
              ]}
              // hasFeedback
            >
              <Select
                showSearch
                placeholder={
                  <span style={{ fontSize: "14px" }}>
                    Alstom, Singapore Airlines, General Electric...
                  </span>
                }
                // optionFilterProp="children"
                onChange={onChangeCompanySelection}
                // onFocus={onFocus}
                // onBlur={onBlur}
                // onSearch={onSearch}
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {companies &&
                  companies.map((company: any) => {
                    return (
                      <Option key={company._id} value={company.name}>
                        {company.name}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

            <div className="upload-section">
              <div className="upload-item">
                <Form.Item
                  name="mobileBanner"
                  label="Card for the mobile app"
                  rules={[
                    {
                      required: true,
                      message: "Upload mobile banner",
                    },
                  ]}
                >
                  <div
                    className="upload-area"
                    onClick={() => {
                      const input = document.createElement("input");
                      input.type = "file";
                      input.accept = "image/*";
                      input.onchange = (e) => {
                        const file = (e.target as HTMLInputElement).files?.[0];
                        if (file && beforeUpload(file)) {
                          handleFileSelect(file, "mobile");
                        }
                      };
                      input.click();
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#1890ff";
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#d9d9d9";
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#d9d9d9";
                      const file = e.dataTransfer.files[0];
                      if (file && beforeUpload(file)) {
                        handleFileSelect(file, "mobile");
                      }
                    }}
                  >
                    {cropLoading && cropImageType === "mobile" ? (
                      <div className="upload-loading">
                        <div className="loading-spinner"></div>
                        <div className="loading-text">Processing image...</div>
                      </div>
                    ) : fileList.length >= 1 ? (
                      <div className="uploaded-image">
                        <img src={fileList[0].url} alt="Mobile banner" />
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemove(fileList[0]);
                          }}
                          className="remove-btn"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="upload-icon">
                          <img src={uploadSvg} alt="Upload" />
                        </div>
                        <div className="upload-text">
                          Click to upload or drag & drop
                        </div>
                        <div className="upload-hint">
                          Formats and sizes: PNG, JPEG - min 256KB, max size
                          10MB
                        </div>
                      </>
                    )}
                  </div>
                </Form.Item>
              </div>

              <div className="upload-item">
                <Form.Item
                  name="jobBanner"
                  label="*Banner for the web page"
                  rules={[
                    {
                      required: true,
                      message: "Upload web banner",
                    },
                  ]}
                >
                  <div
                    className="upload-area"
                    onClick={() => {
                      const input = document.createElement("input");
                      input.type = "file";
                      input.accept = "image/*";
                      input.onchange = (e) => {
                        const file = (e.target as HTMLInputElement).files?.[0];
                        if (file && beforeUpload(file)) {
                          handleFileSelect(file, "banner");
                        }
                      };
                      input.click();
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#1890ff";
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#d9d9d9";
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = "#d9d9d9";
                      const file = e.dataTransfer.files[0];
                      if (file && beforeUpload(file)) {
                        handleFileSelect(file, "banner");
                      }
                    }}
                  >
                    {cropLoading && cropImageType === "banner" ? (
                      <div className="upload-loading">
                        <div className="loading-spinner"></div>
                        <div className="loading-text">Processing image...</div>
                      </div>
                    ) : fileListBanner.length >= 1 ? (
                      <div className="uploaded-image">
                        <img src={fileListBanner[0].url} alt="Web banner" />
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveBanner(fileListBanner[0]);
                          }}
                          className="remove-btn"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="upload-icon">
                          <img src={uploadSvg} alt="Upload" />
                        </div>
                        <div className="upload-text">
                          Click to upload or drag & drop
                        </div>
                        <div className="upload-hint">
                          Formats and sizes: PNG, JPEG - min 256KB, max size
                          10MB
                        </div>
                      </>
                    )}
                  </div>
                </Form.Item>
              </div>
            </div>

            <PreviewBanner
              mobileBannerUrl={
                fileList.length > 0 ? fileList[0].url : undefined
              }
              desktopBannerUrl={
                fileListBanner.length > 0 ? fileListBanner[0].url : undefined
              }
            />

            <Form.Item
              name="countries"
              label={<span style={{ fontSize: 16 }}>Job location(s)</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a location!",
                },
              ]}
              className="section-input"
              // hasFeedback
            >
              <Select
                showSearch
                placeholder="&nbsp; San-Francisco, USA"
                mode="multiple"
                // optionFilterProp="children"
                onSearch={(value: string) => {
                  getPlacePredictions({ input: value });
                  setValue(value);
                  // console.log(evt)
                }}
                loading={isPlacePredictionsLoading}
                // onFocus={onFocus}
                // onBlur={onBlur}
                // onSearch={onSearch}
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {placePredictions &&
                  placePredictions.map((company: any) => {
                    return (
                      <Option
                        key={company.description}
                        value={company.description}
                      >
                        {company.description}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

            <Form.Item
              name="requiredSkills"
              label={<span style={{ fontSize: 16 }}>Expected skills</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a value for skills!",
                },
              ]}
              className="section-input"
              // hasFeedback
            >
              <Select
                showSearch
                placeholder="&nbsp; Strategy, Project management, People management..."
                mode="tags"
                maxTagTextLength={35}
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {skills &&
                  skills.map((skill: any) => (
                    <Option key={skill._id} value={skill.title}>
                      {skill.title}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="fields"
              label={<span style={{ fontSize: 16 }}>Job fields</span>}
              rules={[
                {
                  required: true,
                  message: "Please select job fields!",
                },
              ]}
              className="section-input add-job-form-job-field"
              // hasFeedback
            >
              <TreeSelect
                showSearch
                style={{ width: "100%" }}
                // value={this.state.value}
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                }}
                placeholder="&nbsp;Marketing, Finance, Operations..."
                allowClear
                multiple
                treeDefaultExpandAll
                virtual={false}
                // onChange={this.onChange}
              >
                {jobFieldsTreeList()}
              </TreeSelect>
            </Form.Item>
          </div>

          {/* Yearly Compensation Section */}
          <div className="section-container compensation-section">
            <div className="section-header">
              <h3>Yearly compensation offer (in k)</h3>
            </div>

            <div className="compensation-grid">
              <Form.Item
                name="currencyId"
                label={<span style={{ fontSize: 14 }}>Currency</span>}
                className="section-input add-job-currency-field"
                rules={[
                  {
                    required: true,
                    message: "Please input the Currency",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a currency"
                  // defaultValue={"5eb0fa5158969aa26cb139be"} // default USD key
                  filterOption={(input, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={handleChangeCurrency}
                >
                  {currencies &&
                    currencies.map((currency: any) => (
                      <Option key={currency._id} value={currency.name}>
                        {currency.name.toUpperCase()}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="total"
                label={<span style={{ fontSize: 14 }}>Total</span>}
                className="section-input"
                rules={[
                  {
                    required: true,
                    message: "Please input total compensation",
                  },
                ]}
                // hasFeedback
              >
                <Input
                  type="number"
                  min={0}
                  max={99999}
                  placeholder="0"
                  defaultValue={job && job.yearlyCompensation?.total}
                />
              </Form.Item>

              <Form.Item
                name="base"
                label={<span style={{ fontSize: 14 }}>Base</span>}
                className="section-input"
                // hasFeedback
              >
                <Input
                  type="number"
                  min={0}
                  max={99999}
                  placeholder="0"
                  defaultValue={job && job.yearlyCompensation?.base}
                />
              </Form.Item>

              <Form.Item
                name="onTargetEarnings"
                label={<span style={{ fontSize: 14 }}>On target earnings</span>}
                className="section-input"
                // hasFeedback
              >
                <Input
                  type="number"
                  min={0}
                  max={99999}
                  placeholder="0"
                  defaultValue={job && job.yearlyCompensation?.onTargetEarnings}
                />
              </Form.Item>

              <Form.Item
                name="shortTermIncentives"
                label={
                  <span style={{ fontSize: 14 }}>Short term incentives</span>
                }
                className="section-input"
                // hasFeedback
              >
                <Input
                  type="number"
                  min={0}
                  max={99999}
                  placeholder="0"
                  defaultValue={
                    job && job.yearlyCompensation?.shortTermIncentives
                  }
                />
              </Form.Item>

              <Form.Item
                name="longTermIncentives"
                label={
                  <span style={{ fontSize: 14 }}>Long term incentives</span>
                }
                className="section-input"
                // hasFeedback
              >
                <Input
                  type="number"
                  min={0}
                  max={99999}
                  placeholder="0"
                  defaultValue={
                    job && job.yearlyCompensation?.longTermIncentives
                  }
                  // suffix={"k"}
                />
              </Form.Item>

              <Form.Item
                name="other"
                label={<span style={{ fontSize: 14 }}>Other</span>}
                className="section-input"
                // hasFeedback
              >
                <Input
                  type="text"
                  placeholder="0"
                  maxLength={45}
                  defaultValue={job && job.yearlyCompensation?.other}
                />
              </Form.Item>

              <Form.Item
                name="hideSalary"
                label={
                  <span style={{ fontSize: 14 }}>Hide Compensation offer </span>
                }
                className="section-input"
                valuePropName="checked"
              >
                <Checkbox style={{ marginTop: "10px" }}>
                  Hide Compensation offer
                </Checkbox>
              </Form.Item>
            </div>

            <div className="compensation-comment">
              <Form.Item
                name="comments"
                label={<span style={{ fontSize: 14 }}>Comment</span>}
                className="section-input editorCol"
                // hasFeedback
              >
                <Editor
                  // value={job && job.yearlyCompensation?.comments}
                  apiKey="bgow6d7d89zjmvftzkn8p8gzzhkzyd551egy09ik6j400toe"
                  init={{
                    height: 300,
                    menubar: false,
                    // placeholder: "comments",
                    plugins: [
                      "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
                      "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
                      "save table contextmenu directionality emoticons template paste textcolor",
                    ],
                    inline: true,
                    toolbar:
                      "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
                  }}
                  onEditorChange={handleCommentChange}
                />
              </Form.Item>
            </div>
          </div>
        </Col>

        {/* Right Column */}
        <Col span={12}>
          {/* Job Description Section */}
          <div className="section-container">
            <div className="section-header">
              <h3>Job description</h3>
              {/* <button className="generate-ai-btn">
                <img src={magicIcon} alt="AI" />
                Generate using AI
              </button> */}
            </div>

            <Form.Item
              name="description"
              label={<span style={{ fontSize: 18 }}>Job description</span>}
              rules={[
                {
                  required: true,
                  message: "Please input your job description!",
                },
              ]}
              // hasFeedback
            >
              <Editor
                apiKey="bgow6d7d89zjmvftzkn8p8gzzhkzyd551egy09ik6j400toe"
                init={{
                  height: 520,
                  menubar: true,
                  plugins: [
                    "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
                    "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
                    "save table contextmenu directionality emoticons template paste textcolor",
                  ],
                  toolbar:
                    "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
                }}
                onEditorChange={handleEditorChange}
              />
            </Form.Item>
          </div>

          {/* Reference Target Profile Section */}
          <div className="section-container">
            <div className="section-header">
              <h3>Reference target profile</h3>
              {/* <button className="generate-ai-btn">
                <img src={magicIcon} alt="AI" />
                Generate using AI
              </button> */}
            </div>

            <Form.Item
              name="ReferenceTargetProfile"
              // label={
              //   <span style={{ fontSize: 18 }}>Reference target profile</span>
              // }
            >
              <Space style={{ display: "flex" }} direction="vertical" size={1}>
                {/* <TargetProfile
                  setIsSaveDisabled={setIsSaveDisabled}
                  label="experience" 
                  addAssessment={addAssessment}
                  editAssessment={job?.assessment?.experience}
                />
                <TargetProfile
                  setIsSaveDisabled={setIsSaveDisabled}
                  label="traits"
                  addAssessment={addAssessment}
                  editAssessment={job?.assessment?.traits}
                /> */}
                <AssessmentTable
                  assessmentData={assessments}
                  addAssessment={addAssessment}
                />
              </Space>
            </Form.Item>
          </div>

          {/* Search Details Section */}
          <div className="section-container">
            <div className="section-header">
              <h3>Search details</h3>
            </div>

            <Form.Item
              name="recruiters"
              label={<span style={{ fontSize: 16 }}>Recruiting team</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a value for recruiters!",
                },
              ]}
              className="section-input"
              // hasFeedback
            >
              <Select
                showSearch
                disabled={!companyId && !job}
                mode="multiple"
                placeholder="&nbsp; John Doe, Lynn Roboson, Jim Tan..."
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
                onChange={onRecruiterSelected}
              >
                {recruiters &&
                  recruiters?.map((user: any) => (
                    <Option key={user.email} value={user.email}>
                      {user.email}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="leadRecruiter"
              label={<span style={{ fontSize: 16 }}>Lead recruiter</span>}
              rules={[
                {
                  required: true,
                  message: "Please select a value for lead recruiter!",
                },
              ]}
              className="section-input add-job-lead-recruiter-field"
              // hasFeedback
            >
              <Select
                showSearch
                disabled={selectedRecruiters?.length == 0 && !job}
                placeholder={
                  <div style={{ fontSize: "14px", marginTop: "-2px" }}>
                    &nbsp; John Doe
                  </div>
                }
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {selectedRecruiters &&
                  selectedRecruiters.map((user: any, i: any) => (
                    <Option key={i} value={user.value}>
                      {user.label}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="targetCompanies"
              label={<span style={{ fontSize: "18px" }}>Target companies</span>}
              // rules={[
              //   {
              //     required: true,
              //     message: "Please select a target company!",
              //   },
              // ]}
              // hasFeedback
            >
              <Select
                showSearch
                placeholder="&nbsp; Alstom, Singapore Airlines, General Electric..."
                mode="tags"
                maxTagTextLength={40}
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                {inspiringCompanies &&
                  inspiringCompanies.map((inspiringCompany: any) => (
                    <Option
                      key={inspiringCompany._id}
                      value={inspiringCompany.name}
                    >
                      {inspiringCompany.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="language"
              className="add-job-language-field"
              label={<span style={{ fontSize: "18px" }}>Select language</span>}
              /* no need for required since 'en' is selected by default now  */
              rules={[
                {
                  required: true,
                  message: "Please select a language!",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="French or English"
                /* value for language is "en" by default so need for setting defaultValue prop */
                filterOption={(input, option: any) =>
                  option.children
                    ?.toLowerCase()
                    .indexOf(input?.toLowerCase()) >= 0
                }
              >
                <Option key={"english"} value={"en"}>
                  English
                </Option>
                <Option key={"french"} value={"fr"}>
                  French
                </Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="isConfidential"
              valuePropName="checked"
              className="section-input"
              initialValue={job?.isConfidential}
            >
              <Checkbox>Confidential job posting</Checkbox>
            </Form.Item>
          </div>
        </Col>
      </Row>

      <div className="form-footer">
        <div className="mandatory-fields">
          <span style={{ color: "red" }}>*</span> Mandatory fields
        </div>
        <div className="action-buttons">
          <Button
            className="ant-btn-draft btn_submit_job"
            htmlType="button"
            shape="round"
            disabled={isSaveDisabled}
            loading={draftLoader}
            onClick={saveAsDraftHandler}
            style={{ fontSize: "14px" }}
          >
            Save a Draft
          </Button>
          {hasError || (isLoading && !draftLoader) ? (
            <Button
              className="ant-btn-amber btn_submit_job"
              shape="round"
              disabled={true}
              loading={true}
              style={{ fontSize: "14px" }}
            >
              {/* {editMode || location?.state?.operation == "edit"
                ? "Save"
                : "Post job"} */}
              Save
            </Button>
          ) : (
            <Button
              className="ant-btn-amber btn_submit_job"
              htmlType="submit"
              shape="round"
              disabled={isSaveDisabled}
              loading={isLoading && !draftLoader}
              style={{ fontSize: "14px" }}
            >
              {/* {editMode || location?.state?.operation == "edit"
                ? "Save"
                : "Post job"} */}
              Save
            </Button>
          )}
        </div>
      </div>

      <Modal
        visible={imagePreviewModel}
        title={"Preview image"}
        centered
        footer={null}
        onCancel={() => {
          setImagePreviewModal(false);
        }}
      >
        <img
          alt="example"
          style={{ width: 475, height: 475 }}
          src={imagePreview}
        />
      </Modal>
      <Modal
        className="preview-modal"
        centered
        visible={imagePreviewModelBanner}
        title={"Preview image"}
        footer={null}
        onCancel={() => {
          setImagePreviewModalBanner(false);
        }}
      >
        <img
          alt="example"
          style={{ width: "100%", height: 475 }}
          src={imagePreviewBanner}
        />
      </Modal>

      <CustomImageCrop
        visible={cropModalVisible}
        onCancel={handleCropCancel}
        onApply={handleCropApply}
        imageUrl={cropImageUrl}
        title={
          cropImageType === "mobile"
            ? "Card image for the mobile app"
            : "Banner image for the web page"
        }
        isMobile={cropImageType === "mobile"}
        onLoadingChange={setCropLoading}
      />
    </Form>
  );
};

export default JobForm;
